import { Api } from "@/common/api/Api";
import { AxiosInstance, AxiosResponse } from "axios";
import CalculationRouter from "@/context/calculation/router/CalculationRouter";
import { axiosInstance } from "@/plugins/axios";
import { AnomalyRemovalFormModel } from "@/context/calculation/model/AnomalyRemovalFormModel";

export class CalculationApi extends Api {
  private static _instance: CalculationApi;
  public static instance(): CalculationApi {
    if (!CalculationApi._instance) {
      CalculationApi._instance = new CalculationApi(axiosInstance);
    }
    return CalculationApi._instance;
  }
  constructor(axios: AxiosInstance) {
    super(CalculationRouter.BASE_PATH, axios);
  }

  public async anomalyRemoval(cmd: AnomalyRemovalFormModel): Promise<AxiosResponse> {
    const response = await axiosInstance.post(`${this.baseUrl}/anomaly_removal`, cmd);
    return response;
  }
}
